// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"lO-z","carouselContainer":"mO-z"};